import { getInvitationLink } from '@/api/share'
import { getTeamDetail } from '@/api/team'
import { useStore } from '@/stores'
import { getStandardRole } from '@/views/contests/matchesType.js'

const AVATAR_BASE_URL = import.meta.env.VITE_AVATAR_BASE_URL || ''
const SHARE_LINK_BASE_URL = import.meta.env.VITE_SHARE_LINK_BASE_URL || ''

function isFullUrl(url = '') {
  return /^https?:\/\//i.test(url)
}

function joinUrl(base = '', path = '') {
  if (!base) return path || ''
  if (!path) return base
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

export function buildAvatarUrl(avatar = '') {
  if (!avatar) return ''
  return isFullUrl(avatar) ? avatar : joinUrl(AVATAR_BASE_URL, avatar)
}

export async function fetchInviteInfo() {
  try {
    const res = await getInvitationLink()
    if (res && res?.resultData) {
      return {
        invCode: res.resultData.invCode || '',
        il: res.resultData.il || '',
      }
    }
  } catch (error) {
    console.error('[share] fetch invitation link failed:', error)
  }
  return { invCode: '', il: '' }
}

export function getShareLink({ apiLink = '', scene = 'team', matchId = '', teamId = '' } = {}) {
  // 处理链接 获取链接 ？分开 截取问好后面的固定拼接 SHARE_LINK_BASE_URL
  const params = apiLink.split('?')[1]
  return SHARE_LINK_BASE_URL + '?' + params
}

export function normalizePlayers(rawPlayers = []) {
  if (!Array.isArray(rawPlayers)) return []
  return rawPlayers.map(player => {
    const roleType = Number(player.playerRoleType)
    return {
      pid: player.pid || player.id,
      id: player.id || player.pid,
      name: player.shortName || player.playerName || player.name || 'Unknown',
      avatar: player.logoUrl || player.thumbUrl || player.avatar || '',
      position: getStandardRole(player.position || player.playerRole || player.role || ''),
      teamId: player.teamId || player.tid || '',
      points: Number(player.point ?? player.points ?? 0),
      rating: Number(player.rating ?? player.credits ?? 0),
      isCaptain: roleType === 1 || !!player.isCaptain,
      isViceCaptain: roleType === 2 || !!player.isViceCaptain,
      starting11: Number(player.starting11 || 0),
      substitute: Number(player.substitute || 0),
      dreamTeam: Number(player.dreamTeam || 0),
    }
  })
}

export async function ensureTeamPlayers(teamPayload = {}) {
  if (Array.isArray(teamPayload.players) && teamPayload.players.length > 0) {
    return normalizePlayers(teamPayload.players)
  }
  const teamId = teamPayload.teamId || teamPayload.userTeamId || teamPayload.tid
  if (!teamId) return []
  try {
    const res = await getTeamDetail({ tid: teamId })
    if (res && res?.resultData) {
      const list = Array.isArray(res.resultData) ? res.resultData : res.resultData.players || res.resultData.playerList || []
      return normalizePlayers(list)
    }
  } catch (error) {
    console.error('[share] fetch team players failed:', error)
  }
  return []
}

export function buildSharePayload(scene, payload = {}) {
  const store = useStore()
  const user = store.USERINFO || {}
  const matchInfo = payload.matchInfo || {}
  const roomInfo = payload.roomInfo || {}
  const sceneLabel = scene === 'match' ? 'match' : 'team'
  const title = payload.title || `Cricket ${sceneLabel} share`
  const desc = payload.desc || `${matchInfo.teamAShort || ''} vs ${matchInfo.teamBShort || ''}`.trim()

  return {
    scene: sceneLabel,
    title,
    desc,
    matchInfo,
    roomInfo,
    teamMeta: payload.teamMeta || {},
    userInfo: {
      nickName: user?.nickName || user?.userName || '',
      avatar: buildAvatarUrl(user?.avatar || ''),
      userId: user?.id || user?.userId || '',
    },
    players: normalizePlayers(payload.players || []),
    shareLink: payload.shareLink || '',
    matchId: matchInfo?.mid || payload.matchId || '',
    teamId: payload.teamMeta?.userTeamId || payload.teamId || '',
  }
}
